import React from 'react'

type ImgProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  src: string
  alt?: string
  width?: number | string
  height?: number | string
  fill?: boolean
  priority?: boolean
  unoptimized?: boolean
  layout?: string
  quality?: number
  blurDataURL?: string
  objectFit?: React.CSSProperties['objectFit']
}

export default function Image({
  src,
  alt = '',
  width,
  height,
  fill,
  style,
  objectFit,
  ...rest
}: ImgProps) {
  const imgStyle: React.CSSProperties = {
    ...style,
    ...(objectFit ? { objectFit } : {}),
    ...(fill ? { width: '100%', height: '100%', objectFit: objectFit || 'cover' } : {}),
  }
  const {
    priority: _p,
    unoptimized: _u,
    layout: _l,
    quality: _q,
    blurDataURL: _b,
    ...imgRest
  } = rest as ImgProps

  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      style={imgStyle}
      {...imgRest}
    />
  )
}
